var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9144 8.81564L11.5975 1.88689C10.7013 1.03876 9.29813 1.03876 8.4025 1.88689L1.10313 8.80001C0.660626 9.18626 0.508751 9.79189 0.715626 10.3438C0.922501 10.8944 1.435 11.25 2.02188 11.25H2.5V18.125C2.5 18.47 2.78 18.75 3.125 18.75H16.875C17.22 18.75 17.5 18.47 17.5 18.125V11.25H17.9775C18.5644 11.25 19.0775 10.8938 19.2838 10.3425C19.4906 9.79126 19.3381 9.18501 18.9144 8.81564ZM8.125 17.5V14.375C8.125 13.3413 8.96625 12.5 10 12.5C11.0338 12.5 11.875 13.3413 11.875 14.375V17.5H8.125ZM17.9775 10H16.875C16.53 10 16.25 10.28 16.25 10.625V17.5H13.125V14.375C13.125 12.6519 11.7231 11.25 10 11.25C8.27688 11.25 6.875 12.6519 6.875 14.375V17.5H3.75V10.625C3.75 10.28 3.47 10 3.125 10H2.02188C1.8975 10 1.8075 9.84439 1.94375 9.72439L9.26188 2.79439C9.67563 2.40251 10.3244 2.40251 10.7381 2.79439L18.0738 9.74064C18.1763 9.82939 18.1131 10 17.9775 10Z",
    fill: "#6B6E7B",
    stroke: "#6B6E7B",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.3d597a395f6ca1e1b247efe28e46171a.svg";
export { ForwardRef as ReactComponent };